import { type ComponentType } from 'react';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { MemberNotesTab } from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/MemberNotesTab';
import { MemberProfileTab } from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/MemberProfileTab';
import { PastSessionsTab } from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/PastSessionsTab';
import { SolutionSessionOutputView } from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/SolutionSessionOutputView';
import { CareerPathSelectorPanel } from '@backrs_ui/grow-ui/src/pages/OfficeHours/molecules/CareerPathSelectorPanel';
import { CollegeTypeSelectorPanel } from '@backrs_ui/grow-ui/src/pages/OfficeHours/molecules/CollegeTypeSelectorPanel';
import { ExploreTradeoffsPanel } from '@backrs_ui/grow-ui/src/pages/Result/molecules/ExploreTradeoffs/ExploreTradeoffsPanel';
import { DailyPracticePanel } from '@backrs_ui/grow-ui/src/pages/SatActBooster/components/DailyPracticePanel';
import { type CustomTabId } from '@backrs_ui/grow-ui/src/redux/tabs/customTabIds';

export { type CustomTabId } from '@backrs_ui/grow-ui/src/redux/tabs/customTabIds';

type CustomTabConfig = Readonly<{
  title: string;
  Component: ComponentType;
}>;

const categories = appStrings.modules.officeHours.categories;

export const CUSTOM_TABS: Readonly<Record<CustomTabId, CustomTabConfig>> = {
  tradeoffs: { title: 'Tradeoffs', Component: ExploreTradeoffsPanel },
  memberProfile: { title: categories.member_profile, Component: MemberProfileTab },
  memberSessions: { title: categories.member_sessions, Component: PastSessionsTab },
  memberSolutionSession: {
    title: categories.member_solution_session,
    Component: SolutionSessionOutputView,
  },
  memberNotes: { title: categories.member_notes, Component: MemberNotesTab },
  careerPathSelector: {
    title: categories.career_path_selector,
    Component: CareerPathSelectorPanel,
  },
  collegeTypeSelector: {
    title: categories.college_type_selector,
    Component: CollegeTypeSelectorPanel,
  },
  dailyPractice: {
    title: appStrings.modules.satActBooster.dailyPractice.tabTitle,
    Component: DailyPracticePanel,
  },
};
